import React from 'react';
import { ReactNode } from 'react';
import { styles } from './QuickSearchContent.css';
import { useTrackingContext } from '../Tracking';

export interface QuickSearchContentProps {
  title: string;
  image: ReactNode;
  destinationUrl: string;
  searchTerm?: string;
  variant?: 'card' | 'text';
}

export const QuickSearchContent = ({
  title,
  image,
  destinationUrl,
  searchTerm,
  variant = 'card',
}: QuickSearchContentProps) => {
  const { tracker } = useTrackingContext();

  const handleClick = () => {
    tracker?.trackCustomEvent({
      event: 'custom.search.suggested.click',
      label: title,
      info: {
        url: window.location.href,
      },
      suggestion: {
        type: 'content',
        label: title,
      },
    });
  };

  const highlightedTitle = React.useMemo(() => {
    if (!searchTerm) return title;

    const parts = title.split(new RegExp(`(${searchTerm})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === searchTerm?.toLowerCase() ? <strong key={index}>{part}</strong> : part
    );
  }, [title, searchTerm]);

  if (variant === 'text') {
    return (
      <a href={destinationUrl} onClick={handleClick}>
        {highlightedTitle}
      </a>
    );
  }

  return (
    <a className={styles.container} href={destinationUrl} onClick={handleClick}>
      <div className={styles.image}>{image}</div>
      <div className={styles.title}>{highlightedTitle}</div>
    </a>
  );
};
